import { FinanceStates } from '../apply/apply-models';
import { SellerOrBuyerOrFinanceInst } from '../sessions/login/user.model';

/**
 * used by TransactionHistory tab
 */
export interface Transaction {
    id: number;
    external_transaction_id: string; // "22087014"
    finance_id: number; // 1000044
    transaction_type: string; // "Credit"
    transaction_amount: string; // "2901.141596"
    transaction_currency: string; // "USD"
    credit_account: string; // "78146598"
    mode_of_payment: string; // "Account Transfer"
    debit_from_org_name: string;
    credit_to_org_name: string;
    created_at: string;
    notes: string; // null
    disbursementCurrency: string;
    invoiceCurrency: string;
    transaction_finance_type: string;
    event_name?: any;
    transaction_event_date?: string;
    transaction_event?: string;
    fi_name?: string;
    state?: string;
    actual_disbursal_date?: string;
    approved_due_date?: string;
    approved_disbursal_date?: string;
    product_category: string;
    applicant_id?: number;
    counter_party_id?: number;
    product_type?: string;
    payment_reference_number?: string;
    settled_amount?: number;
    is_lending_bank?: boolean;
}

export enum StatusType {
    'PROCESSING' = 'PROCESSING',
    'PENDING' = 'PENDING',
    'REVERTED' = 'REVERTED',
    'DRAFT' = 'DRAFT',
    'APPROVED' = 'APPROVED',
    'IN_PROCESS' = 'IN_PROCESS',
    'SETTLED' = 'SETTLED',
}

export enum FinanceStateType {
    // 'APPLIED' = FinanceStates.BCO_FINANCE_SAVED,
    'ACCEPTED' = FinanceStates.DTF_FINANCE_ACCEPTED,
    'PROCESSING' = FinanceStates.BANKS_FINANCE_ASSESSED,
    'SETTLED' = FinanceStates.ACCOUNT_SETTLED,
    'APPROVED' = FinanceStates.BCO_TERMS_AGREED,
}

export interface Settings {
    user: {
        userName: string;
        name: string;
        email: string;
        phone: string;
    };
    bank: {
        bank: string;
        branch: string;
        country: string;
        city: string;
        accountName: string;
        accountNumber: string;
        IBAN: string;
        swiftCode: string;
    };
    compliance: {
        panCard: string;
        GST_Num: string;
    };
}

export interface SaveSettingsResponse {
}

/**
 * used by dashboard.
 */
export interface Finance {
    finance_id: number; // 654678,
    fi_name?: string;
    finance_sub_classification: string; // "Pre/Post",
    proof_id: string; // "223456789",
    proof_type: string; // "PO/Sales/Contract",
    amount: number; // 50000.00,
    currency_type: string; // "dollar",
    current_state: string; // "Banks_Finance_Assessed",
    timestamp: string; // "2011-10-05T14:48:00.000Z"
    financeInvoices?: Array<any>;
}


export interface CreditLimitInfo {
    max_limit?: number; // 100000.00,
    availed_amount?: number; // 50000.00,
    currency_type?: string; // "dollar",
    num_of_active_loans?: number; // 5
    total_finance_requested?: number;
    total_finance_approved?: number;
    total_finance_given?: number;
    pending?: number;
    toBeDisbursed?: number;
    due?: number;
    unUtilized?: number;
    approved_amount: number;
    disbursed_amount: number;
    requested_amount: number;
    settled_amount?: number;
    approved_credit_limit?: number;
    approved_date?: Date;
    currency_count?: number;
    applicant_count?: number;
    counter_party_count?: number;
    fi_count?: number;
}

export interface CreditSummarySellerBuyerFiInfo {
    sellers: SellerOrBuyerOrFinanceInst[],
    //buyers: SellerOrBuyerOrFinanceInst[],
    financial_institutions: SellerOrBuyerOrFinanceInst[]
}

// TODO: Shift this required place
export interface Organization {
    id: string;
    organisation_type: string;
    full_name: string;
    organisation_address_primary: string;
    organisation_contact_phone_primary: string;
    organisation_contact_email_primary: string;
    organisation_address_secondary: string | null;
    organisation_contact_phone_secondary: string | null;
    organisation_contact_email_secondary: string | null;
    country: string;
    credit_limit: string;
    created_at: string;
    updated_at: string | null;
    deleted_at: string | null;
}

export interface Notifications {
    id?: string; // new
    message_id: string; // old DEPRECATED "001",
    finance_id: string; // "123456",
    message: string; // "DTF has been created",
    timestamp: string; // "2020-03-09T08:27:07Z"
    has_seen?: boolean;
    owner_type: string;
    actionable: boolean;
    notification_type?: string;
    owner_id?: string | number;
    notification_info?: any;
}
export interface UpcomingTransaction {
    receivable_amount: any;
    actual_disbursal_date: any;
    debit_org_id: number;
    debit_org_name: string;
    created_at: string;
    deleted_at: Date;
    disbursalEvents: Array<Disbursal> | Disbursal | any;
    exporter_acceptance: string;
    credit_org_id: number;
    credit_org_name: string;
    finance_id: number;
    id: number;
    importer_acceptance: string;
    requested_amount?: number;
    updated_at: Date;
    product_type: string;
    receivable_currency?: string;
    product_category: string;
}

export interface Disbursal {
    actual_disbursal_date: Date;
    created_at: Date;
    deleted_at: Date;
    disburse_on_event: string;
    id: number;
    interest_bearer: string;
    interest_rate: string;
    payment_deadline_in_days: number;
    payment_percentage: number;
    payment_term_id: number;
    recourse: string;
    settlement_by: string;
    updated_at: Date;

}

export interface KeyValue {
    name: string;
    value: number;
}


export interface Accounts {
    password: string;
    type: string;
    username: string;
}

export interface InviteOrganization {
    fullName: string;
    primaryContactPhone: number | string;
    primaryContactEmail: string;
}

export interface GetOrganization {
    org_type?: string;
    _limit?: number;
    org_name?: string;
}
